<!-- Head Wiper -->
<app-head-wiper />

<div class="divider"></div>

<!-- Body wiper -->
<div class="body">
  <app-wiper-loading />
</div>

<div class="divider"></div>

<!-- Footer Wiper -->
<div class="footer">
  <div class="footer-item">
    <app-wiper-loading />
  </div>
  <div class="footer-item">
    <app-wiper-loading />
  </div>
</div>
